const ramanJcamp = `
##TITLE=raman
##JCAMP-DX=5.0
##DATA TYPE=LINK
##BLOCKS=1


$$ === CHEMSPECTRA SPECTRUM ORIG ===
##TITLE=raman
##JCAMP-DX=5.00
##DATA TYPE=RAMAN SPECTRUM
##DATA CLASS=XYDATA
##$CSCATEGORY=SPECTRUM
##ORIGIN=Administrator
##OWNER=
##XUNITS=1/CM
##YUNITS=TRANSMITTANCE
##XFACTOR=1
##YFACTOR=5.3768479e-010
##FIRSTX=5001.8166
##LASTX=103.35922
##MAXX=5001.8166
##MAXY=0.5773346466139722
##MINX=103.35922
##MINY=0.0001974486085838
##NPOINTS=2541
##XYDATA= (X++(Y..Y))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$$ === CHEMSPECTRA ===
##$OBSERVEDINTEGRALS= (X Y Z)

##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
##END=


$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=raman
##JCAMP-DX=5.00
##DATA TYPE=RAMANPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=0.07
##MAXX=5001.8166
##MAXY=0.5773346466139722
##MINX=103.35922
##MINY=0.0001974486085838
##$CSSOLVENTNAME=- - -
##$CSSOLVENTVALUE=0
##$CSSOLVENTX=0
##NPOINTS=23
##PEAKTABLE= (XY..XY)
116.85890569291405, 0.2812711020506669
153.50090971653572, 0.1158895202101449
465.92220718110275, 0.21548491848968246
649.1322272992129, 0.09533423986657008
699.2739170157483, 0.06411050289275398
855.4845657480319, 0.04305522193537111
996.2670022598427, 0.04890698207687777
1019.4093205905515, 0.0936985914440095
1181.4055489055122, 0.05234462407853562
1223.833132511811, 0.17724682534161715
1262.403663062992, 0.09429556942422675
1293.260087503937, 0.06265331850421187
1331.8306180551185, 0.10288125347803279
1374.2582016614174, 0.15441207710941407
1412.8287322125984, 0.5773346466139722
1480.3271606771655, 0.09676306030707012
1516.9691647007876, 0.044808283510154416
1572.8964340000002, 0.15104477234356006
1586.3961196929135, 0.07938060199006715
1615.3240176062995, 0.1564257754716172
2924.7935298188977, 0.17262542349619758
2971.0781664803153, 0.04627595113904716
3061.7189132755907, 0.1599702102755257
##END=


$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=raman
##JCAMP-DX=5.00
##DATA TYPE=RAMANPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=0.07
##MAXX=5001.8166
##MAXY=0.5773346466139722
##MINX=103.35922
##MINY=0.0001974486085838
##NPOINTS=23
##PEAKTABLE= (XY..XY)
3061.7189132755907, 0.1599702102755257
2971.0781664803153, 0.04627595113904716
2924.7935298188977, 0.17262542349619758
1615.3240176062995, 0.1564257754716172
1586.3961196929135, 0.07938060199006715
1572.8964340000002, 0.15104477234356006
1516.9691647007876, 0.044808283510154416
1480.3271606771655, 0.09676306030707012
1412.8287322125984, 0.5773346466139722
1374.2582016614174, 0.15441207710941407
1331.8306180551185, 0.10288125347803279
1293.260087503937, 0.06265331850421187
1262.403663062992, 0.09429556942422675
1223.833132511811, 0.17724682534161715
1181.4055489055122, 0.05234462407853562
1019.4093205905515, 0.0936985914440095
996.2670022598427, 0.04890698207687777
855.4845657480319, 0.04305522193537111
699.2739170157483, 0.06411050289275398
649.1322272992129, 0.09533423986657008
465.92220718110275, 0.21548491848968246
153.50090971653572, 0.1158895202101449
116.85890569291405, 0.2812711020506669
##END=

##END=


`;

export default ramanJcamp;
